import * as queryString from "query-string";
import { Location } from "history";

export const getReferral = (location: Location) => {
  const query = queryString.parse(location?.search ?? "");
  return query.q instanceof Array ? query.q[0] : query.q;
};
